module.exports = Netcall;


//////////////////
// WEBPACK FOOTER
// external "Netcall"
// module id = 3oFb
// module chunks = 21